

(function () {
  var videos = document.querySelectorAll('video[data-wc-autoplay]');
  if (!videos.length) return;

  
  
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var k = 0; k < videos.length; k++) {
      try { videos[k].pause(); videos[k].removeAttribute('autoplay'); } catch (e) {  }
    }
    return;
  }

  var pendingPlays = [];

  function attach(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.defaultMuted = true;
    v.muted = true;
    var tryPlay = function () {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {  });
    };
    if (v.readyState >= 2) tryPlay();
    else v.addEventListener('canplay', tryPlay, { once: true });
    
    pendingPlays.push(tryPlay);
  }

  for (var i = 0; i < videos.length; i++) attach(videos[i]);

  
  function nudgeAll() {
    for (var j = 0; j < pendingPlays.length; j++) {
      try { pendingPlays[j](); } catch (e) {  }
    }
  }
  document.addEventListener('touchstart', nudgeAll, { once: true, passive: true });
  document.addEventListener('click', nudgeAll, { once: true });
})();
